import { useState } from "react";
import { getCountryLink } from "../data";

export default function CountryBoard({
  allContinents,
  activeContinent,
  setActiveContinent,
  countries,
  hoveredId,
  setHoveredId,
}) {

  const [query, setQuery] = useState('');

  const filtered = countries.filter((c) =>
    c.name.toLowerCase().includes(query.toLowerCase())
  );
  return (
    <section className="board-wrap">
      <div className="tabs">
        {['All', ...allContinents].map((country) => {
          const active = (activeContinent || 'All') === country;
          return (
            <button
              key={country}
              className={`tab ${active ? 'tab-active' : ''}`}
              onClick={() => setActiveContinent(country === 'All' ? null : country)}
            >
              {country}
            </button>
          );
        })}
      </div>

      <div className="search-bar">
        <input
          type="text"
          id="search"
          placeholder="Search for a country..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      <ul className="country-list">
        {filtered.map((country) => (
          <li key={country.id}>
            <a
              href={getCountryLink(country)}
              target="_parent"
              className={`country-item ${hoveredId === country.id ? 'country-item-active' : ''}`}
              onMouseEnter={() => setHoveredId(country.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <span className="flag">{country.flag}</span>
              <span className="country-name">{country.name}</span>
              <span className="country-chev" aria-hidden>›</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
